// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/documents/actions';
import { getGeom } from '../state/documents/local/actions';

// Components
import DocumentsList from '../components/Documents/DocumentsList';

function mapStateToProps(state) {
	return {
		documents: state.documents,
		groups: state.domains.groups,
		projects: state.login.choosenbyuser
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		getGeom: bindActionCreators(getGeom, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsList);


// WEBPACK FOOTER //
// ./src/containers/DocumentsListContainer.js